const logger = (...messages) => {
  if (process.env.NODE_ENV !== "production") {
    console.log(messages);
  }
};

exports.log = logger;
